import { jsPDF } from "jspdf";
import banner1 from "../../../Assets/ptags/banner.jpg";
import { Url, getAdjustedPrice } from "../../../Services/Api";

import "../../../Assets/ptags/fonts/Montserrat-Bold";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
import "../../../Assets/ptags/fonts/Montserrat-Black";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
import "../../../Assets/ptags/fonts/anton";

const now = new Date();
const timestamp = now
    .toISOString()
    .replace(/[:.]/g, "-")
    .replace("T", "_")
    .split("Z")[0];

export const generatePDFWithoutFinanceBox = (sectionsCount, bannerImg) => {
    const width = 1632;
    const height = 1056;
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: [width, height],
    });

    const sectionWidth = width / 2;
    const sectionHeight = height / 2;
    const bannerImgWidth = width / 2 - 5;
    const bannerImgHeight = 94;

    const maxSectionsPerPage = 4;
    let currentSection = 0;

    while (currentSection < sectionsCount.length) {
        if (currentSection > 0) doc.addPage();

        const sectionsOnThisPage = Math.min(
            maxSectionsPerPage,
            sectionsCount.length - currentSection
        );

        for (let i = 0; i < sectionsOnThisPage; i++) {
            const sectionIndex = currentSection + i;
            const xPos = (i % 2) * (width / 2) + 2.5;
            const yPos = Math.floor(i / 2) * (height / 2) + 2.5;

            if (sectionIndex < sectionsCount.length) {
                // Banner Image
                doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

                // Main Rectangle
                const sectionRectX = xPos + 2.5;
                const sectionRectY = yPos + bannerImgHeight + 4.8;
                const sectionRectWidth = sectionWidth / 2.9;
                // const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);
                const sectionRectHeight = bannerImgHeight + 55;

                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);

                const sectionMainImageX = xPos + sectionRectWidth + 2.5;
                const sectionMainImageWidth = sectionWidth - (sectionRectWidth + 2.5);
                const sectionMainImageHeight = 290;

                const productImageUrl = sectionsCount[sectionIndex]?.image;
                const name = sectionsCount[sectionIndex]?.name;
                const sku = "Model#" + sectionsCount[sectionIndex]?.sku;
                const sale_price = sectionsCount[sectionIndex]?.variations[0].sale_price;
                const regular_price = sectionsCount[sectionIndex]?.variations[0].regular_price;
                const landed_cost = sectionsCount[sectionIndex]?.variations[0].landed_cost;
                const fob_cost = sectionsCount[sectionIndex]?.variations[0].fob_price;

                if (productImageUrl) {
                    doc.addImage(
                        productImageUrl,
                        "JPEG",
                        sectionMainImageX,
                        sectionRectY,
                        sectionMainImageWidth,
                        sectionMainImageHeight
                    );
                }

                doc.setFont("Montserrat-Bold", "bold");
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(14);
                const textX = sectionMainImageX + (sectionMainImageWidth - 15);
                const textY = sectionRectY + 15;
                doc.text(name, textX, textY, { align: "right" });
                doc.setFontSize(16);
                doc.setFont("helvetica", "normal");
                doc.text(sku, textX, textY + 20, { align: "right" });

                doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, "S");








                // Right Rectangle Grid (individuals)
                // ✅ Shifted below the main rectangle and centered horizontally under it
                const rightRectW = sectionRectWidth * 1; // make it slightly narrower than main rect
                const rightRectH = sectionRectHeight - 20  // adjust height proportionally

                // Center horizontally under the main rect
                const rightRectX = sectionRectX + (sectionRectWidth - rightRectW) / 2;

                // Place vertically just below the main rectangle with small spacing
                const rightRectY = sectionRectY + sectionRectHeight + 6;

                doc.setLineWidth(2);
                doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, "S");

                const col1 = rightRectW * 0.3;
                const col2 = rightRectW * 0.2;
                const col3 = rightRectW * 0.3;
                const col4 = rightRectW * 0.2;
                const rowHeight = rightRectH / 4;

                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);

                for (let r = 1; r < 5; r++) {
                    const y = rightRectY + r * rowHeight;
                    doc.line(rightRectX, y, rightRectX + rightRectW, y);
                }

                const colX1 = rightRectX + col1;
                const colX2 = colX1 + col2;
                const colX3 = colX2 + col3;
                doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH);
                doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH);
                doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH);

                const values = sectionsCount[sectionIndex]?.individuals || [];
                const itemsPerRow = 2;
                const totalRows = Math.ceil(values.length / itemsPerRow);

                for (let r = 0; r < totalRows; r++) {
                    const y = rightRectY + (r + 1) * rowHeight;
                    const leftIndex = r * itemsPerRow;
                    const rightIndex = leftIndex + 1;

                    if (values[leftIndex]) {
                        const left = values[leftIndex];
                        const leftLabel = left.inputValue || "";
                        const leftSlug = left.p_price ? "$" + left.p_price : "";
                        const leftLabelX = rightRectX + col1 / 2 - 30;
                        const leftSlugX = rightRectX + col1 + col2 / 2 - 15;
                        const textY = y - rowHeight / 2 + 2;

                        doc.setFont("Montserrat-BoldItalic", "bolditalic");
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(12);
                        doc.text(leftLabel, leftLabelX, textY, { align: "left" });
                        doc.setTextColor(252, 0, 0);
                        doc.text(leftSlug, leftSlugX, textY, { align: "left" });
                    }

                    if (values[rightIndex]) {
                        const right = values[rightIndex];
                        const rightLabel = right.inputValue || "";
                        const rightSlug = right.p_price ? "$" + right.p_price : "";
                        const rightLabelX = rightRectX + col1 + col2 + col3 / 2 - 30;
                        const rightSlugX = rightRectX + col1 + col2 + col3 + col4 / 2 - 15;
                        const textY = y - rowHeight / 2 + 2;

                        doc.setFont("Montserrat-BoldItalic", "bolditalic");
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(12);
                        doc.text(rightLabel, rightLabelX, textY, { align: "left" });
                        doc.setTextColor(252, 0, 0);
                        doc.text(rightSlug, rightSlugX, textY, { align: "left" });
                    }
                }
















                // Divider
                const lineY = sectionRectY + sectionRectHeight / 4;
                doc.setLineWidth(2);
                // doc.line(sectionRectX, lineY, sectionRectX + sectionRectWidth, lineY);

                const subSection1Width = sectionWidth / 2.9;
                const wasPriceStartY = yPos;

                // Price texts
                const text1 = sectionsCount[sectionIndex]?.variations[0].value;
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(40, 142, 169);
                doc.setFontSize(11);
                const text1Width = doc.getTextWidth(text1);
                const wasPriceStartX1 = xPos + (subSection1Width - text1Width) / 2;
                doc.text(text1, wasPriceStartX1, wasPriceStartY + 120);

                const text2 = "was $" + regular_price;
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(16);
                const text2Width = doc.getTextWidth(text2);
                const wasPriceStartX2 = xPos + (subSection1Width - text2Width) / 2;
                doc.text(text2, wasPriceStartX2, wasPriceStartY + 140);

                const text3 = "$" + sale_price;
                doc.setFont("Montserrat-Black", "normal");
                doc.setTextColor(253, 0, 0);
                doc.setFontSize(50);
                const text3Width = doc.getTextWidth(text3);
                const wasPriceStartX3 = xPos + (subSection1Width - text3Width) / 2;
                doc.text(text3, wasPriceStartX3, wasPriceStartY + 190);





                // 🟦 Two small rectangles inside main box
                const innerPadding = 10; // margin from edges
                const rectGap = 10; // gap between rectangles
                const smallRectHeight = 25;
                const smallRectWidth = (sectionRectWidth - innerPadding * 2 - rectGap) / 2;

                // Position (bottom of main box)
                const smallRectY = sectionRectY + sectionRectHeight - smallRectHeight - innerPadding;
                const smallRectX1 = sectionRectX + innerPadding;
                const smallRectX2 = smallRectX1 + smallRectWidth + rectGap;

                doc.setLineWidth(1);

                // ✅ Draw first rectangle (outline only)
                doc.setDrawColor(89, 89, 89);
                doc.rect(smallRectX1, smallRectY, smallRectWidth, smallRectHeight, "S");

                // ✅ Draw second rectangle (filled)
                doc.setFillColor(89, 89, 89); // teal color fill (you can change)
                doc.rect(smallRectX2, smallRectY, smallRectWidth, smallRectHeight, "FD"); // F=fill, D=draw border

                // ✅ Add text inside both
                doc.setFont("Montserrat-Bold", "bold");
                doc.setFontSize(10);

                // Text colors
                doc.setTextColor(89, 89, 89);
                const label1 = landed_cost ? `LC $${landed_cost}` : "";
                const label2 = fob_cost ? `FOB $${fob_cost}` : "";

                // Center text
                const label1Width = doc.getTextWidth(label1);
                const label2Width = doc.getTextWidth(label2);

                doc.text(label1, smallRectX1 + (smallRectWidth - label1Width) / 2, smallRectY + smallRectHeight / 2 + 3);

                // White text for filled box
                doc.setTextColor(255, 255, 255);
                doc.text(label2, smallRectX2 + (smallRectWidth - label2Width) / 2, smallRectY + smallRectHeight / 2 + 3);




                // if (sectionsCount[sectionIndex]?.variations.length > 1) {
                //     // ✅ Base Y position — now relative to section
                //     // const groupStartY = sectionRectY + sectionMainImageHeight - 5;
                //     const groupStartY = sectionRectY + (sectionMainImageHeight - 5); // 10 = small gap below main image


                //     // ✅ Define container
                //     doc.setLineWidth(2);
                //     doc.setDrawColor(71, 74, 119);

                //     // ✅ Container dimensions
                //     const containerX = sectionRectX + 0; // small left padding inside section
                //     const containerY = groupStartY + 5;
                //     const containerWidth = sectionWidth - 10; // equal width for both left/right sections
                //     const containerHeight = 130;

                //     // 🟦 Draw main container (transparent)
                //     doc.rect(containerX, containerY, containerWidth, containerHeight, "S");

                //     // ✅ Use section width
                //     const pageWidth = sectionWidth;
                //     const margin = sectionRectX + 10; // shift based on each section's X
                //     const contentWidth = pageWidth - 40;
                //     const colSpacing = contentWidth / 3; // 3 columns

                //     const startX1 = margin;
                //     const startX2 = startX1 + colSpacing + 10;
                //     const startX3 = startX2 + colSpacing + 10;

                //     // ✅ Calculate vertical separator X positions
                //     const sepX1 = containerX + containerWidth / 3;
                //     const sepX2 = containerX + (2 * containerWidth) / 3;

                //     // ✅ Add vertical separators inside the box
                //      doc.setLineWidth(0.5);
                //     doc.line(sepX1, containerY, sepX1, containerY + containerHeight);
                //     doc.line(sepX2, containerY, sepX2, containerY + containerHeight);

                //     // ✅ Prepare variations
                //     const variations = sectionsCount[sectionIndex].variations.slice(1);
                //     const perCol = 4;
                //     const col1 = variations.slice(0, perCol);
                //     const col2 = variations.slice(perCol, perCol * 2);
                //     const col3 = variations.slice(perCol * 2, perCol * 3);

                //     const renderColumn = (items, startX) => {
                //         items.forEach((variation, i) => {
                //             const baseY = groupStartY + 25 + i * 28;
                //             const name = variation?.value || "N/A";
                //             const w_price = "Price : ";
                //             const price = `$${variation?.sale_price || "0.00"}`;
                //             const landed = variation?.landed_cost ?  `LC : $${variation?.landed_cost || "0.00"}` : "";
                //             const fob = variation?.fob_price ?  `FOB : $${variation?.fob_price || "0.00"}` : "";

                //             doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                //             doc.setTextColor(0, 0, 0);
                //             doc.setFontSize(9);
                //             doc.text(name, startX, baseY);

                //             doc.setTextColor(89, 89, 89);
                //             doc.text(w_price, startX, baseY + 12);

                //             doc.setTextColor(253, 0, 0);
                //             doc.text(price, startX+33, baseY + 12);

                //             doc.setTextColor(89, 89, 89);
                //             doc.text(landed, startX + 100, baseY + 12);

                //             doc.setTextColor(89, 89, 89);
                //             doc.text(fob, startX + 180, baseY + 12);
                //         });
                //     };

                //     renderColumn(col1, startX1);
                //     renderColumn(col2, startX2);
                //     renderColumn(col3, startX3);
                // }




                // ✅ Always draw the design box, even if no variations exist
const variationsExist = sectionsCount[sectionIndex]?.variations?.length > 1;

// ✅ Base Y position
const groupStartY = sectionRectY + (sectionMainImageHeight - 5);

// ✅ Define container
doc.setLineWidth(2);
doc.setDrawColor(71, 74, 119);

// ✅ Container dimensions
const containerX = sectionRectX + 0;
const containerY = groupStartY + 5;
const containerWidth = sectionWidth - 10;
const containerHeight = 130;

// 🟦 Draw main container (transparent)
doc.rect(containerX, containerY, containerWidth, containerHeight, "S");

// ✅ Draw vertical separators
const sepX1 = containerX + containerWidth / 3;
const sepX2 = containerX + (2 * containerWidth) / 3;
doc.setLineWidth(0.5);
doc.line(sepX1, containerY, sepX1, containerY + containerHeight);
doc.line(sepX2, containerY, sepX2, containerY + containerHeight);

if (variationsExist) {
  // ✅ Prepare variations (skip first)
  const variations = sectionsCount[sectionIndex].variations.slice(1);
  const perCol = 4;
  const col1 = variations.slice(0, perCol);
  const col2 = variations.slice(perCol, perCol * 2);
  const col3 = variations.slice(perCol * 2, perCol * 3);

  const pageWidth = sectionWidth;
  const margin = sectionRectX + 10;
  const contentWidth = pageWidth - 40;
  const colSpacing = contentWidth / 3;

  const startX1 = margin;
  const startX2 = startX1 + colSpacing + 10;
  const startX3 = startX2 + colSpacing + 10;

  const renderColumn = (items, startX) => {
    items.forEach((variation, i) => {
      const baseY = groupStartY + 25 + i * 28;
      const name = variation?.value || "N/A";
      const w_price = "Price : ";
      const price = `$${variation?.sale_price || "0.00"}`;
      const landed = variation?.landed_cost ? `LC : $${variation?.landed_cost}` : "";
      const fob = variation?.fob_price ? `FOB : $${variation?.fob_price}` : "";

      doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(9);
      doc.text(name, startX, baseY);

      doc.setTextColor(89, 89, 89);
      doc.text(w_price, startX, baseY + 12);

      doc.setTextColor(253, 0, 0);
      doc.text(price, startX + 33, baseY + 12);

      doc.setTextColor(89, 89, 89);
      doc.text(landed, startX + 100, baseY + 12);
      doc.text(fob, startX + 180, baseY + 12);
    });
  };

  renderColumn(col1, startX1);
  renderColumn(col2, startX2);
  renderColumn(col3, startX3);

} else {
  // 🟥 No variations — show placeholder text
  doc.setFont("Montserrat-Bold", "bold");
  doc.setFontSize(11);
  doc.setTextColor(120, 120, 120);
}


            }
        }

        // Page Dividers
        doc.setLineDashPattern([10, 5], 0);
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        doc.line(0, height / 2, width, height / 2);
        doc.line(width / 2, 0, width / 2, height);

        currentSection += sectionsOnThisPage;
    }

    doc.save(`price-tags-simple_${timestamp}.pdf`);
};
